import { useStores } from 'src/contexts/stores';

export default function useCart() {
  const { cart } = useStores();

  return cart;
}
